import { render } from "./BrowserLink.vue?vue&type=template&id=fff37c80&ts=true"
import script from "./BrowserLink.vue?vue&type=script&lang=ts"
export * from "./BrowserLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__